<template>
  <fin-data-loader ref="keyFiguresLoader" :resolver="loadData">
    <template #content>
      <div v-if="keyFigures.length > 0">
        <v-row v-for="(figure, index) in keyFigures"
               :key="index"
               v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
          <v-col cols="12">
            <h3>{{ figure.name }} <sup style="font-size: 14px; top: -12px;">1</sup></h3>

            <p v-if="!checkIfEstimatesExist(figure.rows)">Für dieses Wertpapier liegen von unserem Datenlieferanten
              derzeit keine Prognosezahlen für die kommenden Jahre vor</p>

            <fin-data-table :class="$vuetify.breakpoint.smAndDown ? 'mb-5' : 'mb-10'"
                            :headers="tableHeaders(figure.rows)"
                            :hide-default-header="$vuetify.breakpoint.smAndDown"
                            :resolver="figure.rows"
                            hide-default-footer/>
          </v-col>
        </v-row>
        <v-row v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
          <v-col cols="12">
            <div class="mb-5">
              <div>
                <span style="width: 20px; display: inline-block;">(<sup style="font-weight: bold;">1</sup>)</span>
                <span>Alle o.g. Kennzahlen basieren auf Daten von Factset. Für Unternehmen außerhalb des Euroraums erfolgt
                die Umrechnung in Euro zu Wechselkursen am Bilanzstichtag. finCraft übernimmt keine Garantie für die
                Richtigkeit der hier veröffentlichen Zahlen.</span>
              </div>
              <div>
                <span style="width: 20px; display: inline-block;">(<sup style="font-weight: bold;">2</sup>)</span>
                <span>Die Zahlen zum aktuellen und zukünftigen Geschäftsjahr basieren auf Prognosen. Falls sie auf den Aktienkurs Bezug nehem (z.B. KGV, Dividendenrendite etc.) wird der Vortageschlußkurs herangzogen.</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>

      <div v-else>
        <v-row v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
          <v-col cols="12">
            <p>Keine Kennzahlen verfügbar</p>
          </v-col>
        </v-row>
      </div>
    </template>
  </fin-data-loader>
</template>

<script>
import FinDataLoader from "@/components/common/DataLoader"
import {finShareAPI} from "@/js/finAPI"
import FinDataTable from "@/components/common/DataTable/FinDataTable"
import {TablePresets} from "@/components/common/DataTable/DefaultHeaders"

export default {
  name: 'FinCompanyPageKeyFigures',
  components: {FinDataTable, FinDataLoader},
  props: {
    /** The company id */
    id: {
      type: String
    },
  },
  data() {
    return {
      keyFigures: [],
    }
  },
  methods: {
    async loadData() {
      const result = await finShareAPI.getShareKeyFigures(this.id)

      if (result && result.keyFigures) {
        this.keyFigures = result.keyFigures.filter(kf => kf.rows && kf.rows.length > 0)
      }
    },
    tableHeaders(figureRows) {
      return TablePresets.createShareKeyFiguresTableHeader(figureRows)
    },
    checkIfEstimatesExist(figureRows) {
      const cols = figureRows.flatMap(r => r.cols)
      const nextYear = (new Date().getFullYear()) + 1

      return cols.find(t => t.n === nextYear.toString())
    },
  },
  watch: {
    id() {
      // url param id changes e.g. because of search -> reload page data
      this.$refs.keyFiguresLoader._fetchData()
    },
  },
}
</script>

<style scoped>

</style>
